module.exports = __webpack_public_path__ + "static/media/img-thumbnail-luckysix@2x.e648aad1.png";